import { Button } from '@components/button';
import { useApiState } from '@features/maintenance-mode/useApiState';
import { useI18nContext } from '@i18n/i18n-react';
import { useAuth } from '@providers/AuthProvider';
import { PropsWithChildren, ReactElement } from 'react';
import { SignInActions } from './authentication/SignInActions';

interface UnauthorizedProps {
    path: string;
}

export function Unauthorized(props: UnauthorizedProps): ReactElement {
    const { LL } = useI18nContext();

    if (props.path.includes('entrylink')) {
        return (
            <div className="global-error">
                <div className="global-error-content">
                    <h2>{LL.INVALID_LINK()}</h2>
                    <p>{LL.LINK_NOT_EXIST()}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="global-error">
            <div className="global-error-content">
                <h2>{LL.ACCESS_NOT_GRANTED()}</h2>
                <p>{LL.CONTACT_ADMIN()}</p>
                <Button title={LL.LOGOUT()} onClick={() => SignInActions.signOut()} />
            </div>
        </div>
    );
}

export function UnauthorizedWrapper(props: PropsWithChildren) {
    const apiState = useApiState();
    const { tenant } = useAuth();

    // when there is no tenant and user has signed in he/she was not appointed to the default tenant of the organization
    if (apiState.unauthorized || !tenant) {
        return <Unauthorized path={location.pathname} />;
    }

    return <>{props?.children ?? null}</>;
}
